export const ACCOUNT_TYPE = {
    OWNER: "Owner",
    ADMIN: "Admin",
  }
  
  export const HOUSE_STATUS = {
    DRAFT: "Draft",
    PUBLISHED: "Published",
  }